import { useEffect, useState } from 'react';
import styles from '../addImage.module.css';

export function AddVideoPreview({ video }) {
	const [src, setSrc] = useState(null);

	useEffect(() => {
		if (video?.file) {
			const objectUrl = URL.createObjectURL(video.file);
			setSrc(objectUrl);
			return () => URL.revokeObjectURL(objectUrl);
		}
		setSrc(video?.url || null);
	}, [video]);

	return (
		<div className={styles.addImageRoot}>
			<div className={styles.addImagePreview}>
				{src && (
					<video
						className={styles.addImagePreviewImg}
						src={src}
						controls
						preload='metadata'
					/>
				)}
			</div>
		</div>
	);
}

export default AddVideoPreview;
